import { render, staticRenderFns } from "./ContentsResults.vue?vue&type=template&id=0c79bf76&scoped=true&"
import script from "./ContentsResults.vue?vue&type=script&lang=js&"
export * from "./ContentsResults.vue?vue&type=script&lang=js&"
import style0 from "./ContentsResults.vue?vue&type=style&index=0&id=0c79bf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79bf76",
  null
  
)

export default component.exports